/**
 * Phân biệt nhóm tiêu chí
 * Created: 27/05/2025
 */
export default {
  ProfessionalBusiness: 1,
  AssetRepair: 2,
  AssetPurchase: 3,
  Other: 4,
};
